<script setup lang="ts">
import type { Tile } from '../../types/cmsTile';
import type { Schemas } from '@shopware/api-client/api-types';

const props = defineProps<{
    tile: Tile;
    media?: Schemas['Media'];
}>();

const { getCmsLink } = useFormatCmsLink();
const link = await getCmsLink(props.tile.url.value);
</script>

<template>
    <LocaleLink
        v-if="link"
        :to="link"
        class="grid items-baseline gap-4 bg-neutral-300 p-6 md:grid-cols-1 md:gap-6 md:p-6"
        :class="{
            'grid-cols-[minmax(2rem,_4rem)_1fr]': !tile.imageFullScreen.value,
        }"
    >
        <SharedInformationTileContent
            :tile="tile"
            :media="media"
        />
    </LocaleLink>

    <div
        v-else
        class="grid items-baseline gap-4 bg-neutral-300 p-6 md:grid-cols-1 md:gap-6 md:p-6"
        :class="{
            'grid-cols-[minmax(2rem,_4rem)_1fr]': !tile.imageFullScreen.value,
        }"
    >
        <SharedInformationTileContent
            :tile="tile"
            :media="media"
        />
    </div>
</template>
